module.exports = __webpack_public_path__ + "static/img/5.fd227b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/sp/5.png
// module id = f52p
// module chunks = 0